import React, { Fragment, useState } from 'react';
import { useFormik } from 'formik';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import axios from 'axios';

import Header from '../components/header';
import Footer from '../components/footer';
import requireAuth from '../requireAuth';
import validate from '../utils/sell-utils';
import Spinner from 'react-spinkit';
import { USER_PRODUCTS } from './shop';

const GET_CATEGORIES = gql`
  query GET_CATEGORIES {
    categories{
      id
      name
    }
  }
`;

const CREATE_PRODUCT = gql`
  mutation CREATE_PRODUCT(
    $name: String,
    $description: String,
    $image_url: String,
    $price: Int,
    $category: String) {
    createProduct(data: {
      name: $name,
      description: $description,
      image_url: $image_url,
      price: $price,
      category: $category
    }) {
      id
      name
      description
      image_url
      price,
      category{
        id
        name
      }
    }
  }
`;

const Sell = (props) => {

  const [image, setImage] = useState({
    image_url: '',
    largeImage: ''
  });

  const [createProduct, { loading: mutationLoading }] = useMutation(CREATE_PRODUCT);

  const uploadFile = async (e) => {
    const files = e.target.files;
    const data = new FormData();
    data.append('file', files[0]);
    data.append('upload_preset', 'zenonstore');

    await axios.post('https://api.cloudinary.com/v1_1/nuclues/image/upload', data)
    .then(({ data }) => {
      setImage({
        image_url: data.secure_url,
        largeImage: data.eager[0].secure_url
      });
    });
  }
  console.log(image);

  const formik = useFormik({
    initialValues: {
      name: '',
      category: '',
      price: '',
      description: ''
    },
    validate,
    onSubmit: async (values, { setErrors }) => {
      try {
        if (image.image_url) {
          const response = await createProduct({
            variables: {
              ...values,
              image_url: image.largeImage
            },
            update: (cache, { data: { createProduct } }) => {
              const data = cache.readQuery({ query: USER_PRODUCTS });
              data.getUserProducts.push(createProduct);
              cache.writeQuery({ query: USER_PRODUCTS, data });
            }
          });
          props.history.push('/shop');
        }
      } catch (err) {
        const errorMessage = err.graphQLErrors[0].message;
        console.log(errorMessage);
        // setErrors({})
      }
    }
  })

  const { loading, error, data } = useQuery(GET_CATEGORIES);
  if (loading) return (<Spinner name="circle" />);
  if (error) return 'error';

  return (
    <Fragment>
      <Header />
      <section className="sell">
        <form onSubmit={formik.handleSubmit} className="form">
          <div className="form__group">
            <input
              id="name"
              name="name"
              type="text"
              onChange={formik.handleChange}
              value={formik.values.name}
              className={"form__input " + (formik.errors.name ? 'error' : '')}
              placeholder="Name" />
            {formik.errors.name ? <span className="danger">{formik.errors.name}</span> : null}
          </div>
          <div className="form__group">
            <select
              id="category"
              name="category"
              onChange={formik.handleChange}
              value={formik.values.category}
              className={"form__input " + (formik.errors.category ? 'error' : '')}>
              <option value="">Select category</option>
              {data.categories.map(category => {
                return (
                  <option
                    key={category.id}
                    value={category.id}>
                    {category.name}
                  </option>
                )
              })}
            </select>
            {formik.errors.category ? <span className="danger">{formik.errors.category}</span> : null}
          </div>
          <div className="form__group">
            <input
              id="price"
              name="price"
              type="number"
              onChange={formik.handleChange}
              value={formik.values.price}
              className={"form__input " + (formik.errors.price ? 'error' : '')}
              placeholder="Price"/>
             {formik.errors.price ? <span className="danger">{formik.errors.price}</span> : null}
          </div>
          <div className="form__group">
            <textarea
              id="description"
              name="description"
              onChange={formik.handleChange}
              value={formik.values.description}
              className={"form__input " + (formik.errors.description ? 'error' : '')}
              placeholder="Description"></textarea>
             {formik.errors.description ? <span className="danger">{formik.errors.description}</span> : null}
          </div>
          <div className="form__group">
            <input
              id="file"
              name="file"
              type="file"
              className="form__input"
              placeholder="Upload an image"
              onChange={uploadFile}
            />
             {/* <span className="danger">invalid password</span> */}
          </div>
          <button className="btn form__btn" type="submit">
            Save {mutationLoading ? <span className="ml-3"><Spinner name="circle" /></span> : null}
          </button>
        </form>
      </section>
      {/* <Footer /> */}
    </Fragment>
  )
}

export default requireAuth(Sell);